import { render } from "./ImportarEmMassa.vue?vue&type=template&id=79096f5f&scoped=true"
import script from "./ImportarEmMassa.vue?vue&type=script&lang=js"
export * from "./ImportarEmMassa.vue?vue&type=script&lang=js"

import "./ImportarEmMassa.vue?vue&type=style&index=0&id=79096f5f&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79096f5f"]])

export default __exports__